var isArray = require('./isArray'),
    stringToPath = require('./_stringToPath');

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

module.exports = castPath;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_castPath.js
 ** module id = 584
 ** module chunks = 0 5
 **/